import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { CustomerProvider } from "@/context/CustomerContext";
import Home from "@/pages/Home";
import PaymentPage from "@/pages/PaymentPage";
import OrderStatusPage from "@/pages/OrderStatusPage";
import MyOrdersPage from "@/pages/MyOrdersPage";
import StaffLogin from "@/pages/StaffLogin";
import StaffDashboard from "@/pages/StaffDashboard";
import AuthCallback from "@/pages/AuthCallback";
import { MaintenanceGate } from "@/components/MaintenanceGate";

const gate = (el) => <MaintenanceGate>{el}</MaintenanceGate>;

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={gate(<Home />)} />
      <Route path="/bayar/:id" element={gate(<PaymentPage />)} />
      <Route path="/pesanan" element={gate(<MyOrdersPage />)} />
      <Route path="/pesanan/:id" element={gate(<OrderStatusPage />)} />
      <Route path="/staf/login" element={<StaffLogin />} />
      <Route path="/staf" element={<StaffDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <CustomerProvider>
        <CartProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </CustomerProvider>
    </AuthProvider>
  );
}

export default App;
